import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  ButtonToolbar,
} from 'react-bootstrap';

import Page from '../Page/Page';
import EmptyProperties from './EmptyProperties';
// models
import Property from '../../models/Property';
import Passcode from '../../models/Passcode';
// components
import PropertyInfo from '../../components/Property/PropertyInfo';
import PasscodeList from '../../components/Property/PasscodeList';
// import AddPropertyBtn from '../../components/Buttons/AddProperty';
import EditPropertyBtn from '../../components/Buttons/EditProperty';
// import DeletePropertyBtn from '../../components/Buttons/DeleteProperty';
import AddPasscodeBtn from '../../components/Buttons/AddPasscode';
// stores
import PropertyStore from '../../stores/PropertyStore';
import PasscodeStore from '../../stores/PasscodeStore';
// css
import './Properties.css';

const Properties = observer(
class Properties extends Component {
  componentDidMount() {
    const property = PropertyStore.selectedProperty;
    if (property && !property.twilioNumber) {
      PropertyStore.waitFor(property.id, "twilioNumber");
    }
  }

  render() {
    const passcodes = PasscodeStore.passcodes;
    const property = PropertyStore.selectedProperty;

    if (!PropertyStore.properties.length) {
      return (<EmptyProperties onPropertySave={this.onPropertySave} />);
    }

    return (
      <Page
        title={(property && property.name) || "My property"}
        renderControlsInline={false}
        controls={this.renderPageControls()}>
        <div className="Properties-body">
          <div className="Properties-info">
            <PropertyInfo property={property} />
          </div>
          <div className="Properties-passcode">
            <PasscodeList passcodes={passcodes} />
          </div>
        </div>
      </Page>
    );
  }

  renderPageControls = () => {
    const property = new Property(PropertyStore.selectedProperty.get());
    return (
      <ButtonToolbar>
        <AddPasscodeBtn />
        {/* <AddPropertyBtn /> */}
        <EditPropertyBtn property={property} />
        {/* <DeletePropertyBtn property={property} /> */}
      </ButtonToolbar>
    );
  }

  onPropertySave = (property) => {
    PropertyStore.add(property)
    .then(PasscodeStore.setProperty)
    .then(() => PasscodeStore.add(new Passcode()));
  }
});

export default Properties;


// WEBPACK FOOTER //
// ./src/pages/Properties/Properties.js